import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from 'react-error-boundary';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { useLogger } from 'react-use';

import ErrorFallback from 'components/error/ErrorFallback';
import PageTemplate from 'components/page-template/PageTemplate';
import UserContextProvider from 'contexts/user/UserContextProvider';
import RouteIndex from 'routes/RouteIndex';
import { newTheme } from 'themes/theme';

console.log('*************** App Started ***************');

const router = createBrowserRouter([
  { path: '*', element: <Root /> },
]);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
    },
  },
});

function Root(): JSX.Element {
  useLogger('App');

  return (
    <ChakraProvider theme={newTheme} toastOptions={{ defaultOptions: { position: 'top', variant: 'solid' } }}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <QueryClientProvider client={queryClient}>
          <UserContextProvider>
            <PageTemplate>
              <RouteIndex />
            </PageTemplate>
          </UserContextProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </ChakraProvider>
  );
}

function App(): JSX.Element {
  return <RouterProvider router={router} />;
}

export default App;
